<template>
  <scroll-layout class="scan-coupons-detail">
    <template slot="header">
      <div v-if="pageButtons.length > 0" class="button-wrap">
        <ykc-button
          v-for="(button, index) in pageButtons"
          :key="button.id || index"
          v-bind="button"
          @click="button.handleClick(button, $event)">
          {{ button.text }}
        </ykc-button>
      </div>
    </template>
    <div>
      <ykc-detail :tips="true" :isLine="true" :titles="['退款单信息']" :className="'all'">
        <div slot="cvHead-lt" class="flex switch-box">
          <div class="refund-status">{{ statusStr(detail.status) }}</div>
        </div>
        <div slot="cvBody">
          <div class="flex form-detail">
            <div class="fl-right">
              <ykc-form :label-position="'left'" label-width="130px" class="form-left">
                <ykc-detail-item :label="'充电用户：'">
                  <span>{{ dealData(detail.userAccount) }}</span>
                </ykc-detail-item>
                <ykc-detail-item :label="'活动编号：'">
                  <span>{{ dealData(detail.joinActivityId) }}</span>
                </ykc-detail-item>
                <ykc-detail-item :label="'退款金额：'">
                  <span>{{ dealData(detail.refundAmt) }}元</span>
                </ykc-detail-item>
                <ykc-detail-item :label="'充电用户账号：'">
                  <span>{{ dealData(detail.userAccount) }}</span>
                </ykc-detail-item>
              </ykc-form>
              <ykc-form :label-position="'left'" label-width="130px" class="form-right">
                <ykc-detail-item :label="'客服人员：'">
                  <span>
                    {{ detail.createdNo }}
                  </span>
                </ykc-detail-item>
                <ykc-detail-item :label="'审核人员：'">
                  <span>
                    {{ detail.modifiedNo }}
                  </span>
                </ykc-detail-item>

                <ykc-detail-item :label="'申请时间：'">
                  <span>{{ dealData(detail.createdTime) }}</span>
                </ykc-detail-item>
                <ykc-detail-item :label="'审核时间：'">
                  <span>{{ dealData(detail.modifiedTime) }}</span>
                </ykc-detail-item>
              </ykc-form>
            </div>
          </div>
        </div>
      </ykc-detail>
      <ykc-detail
        v-if="detail?.cardCouponList?.length"
        :tips="true"
        :isLine="true"
        :titles="['作废的卡券信息']"
        :className="'all'">
        <div slot="cvBody">
          <div class="form-detail">
            <ykc-form :label-position="'left'" label-width="100px" class="list-left">
              <ykc-detail-item label="卡券信息：">
                <ykc-table
                  :columns="tableColumns"
                  :tableConfig="tbConfig"
                  :data="detail.cardCouponList || []"></ykc-table>
              </ykc-detail-item>
            </ykc-form>
          </div>
        </div>
      </ykc-detail>
    </div>
  </scroll-layout>
</template>

<script>
  import { cSideDriverAccount } from '@/service/apis';

  export default {
    data() {
      return {
        scopeTypeDes: {
          1: '按城市',
          2: '按商户',
          3: '按电站分组',
          4: '全部电站',
        },

        searchParams: {},
        pageButtons: [
          {
            id: '1',
            text: '返回',
            type: 'plain',
            handleClick: () => {
              this.$router.go(-1);
            },
          },
        ],
        detail: {},
        carProperty: [],
        tbConfig: {
          stripe: false,
          border: false,
          // eslint-disable-next-line consistent-return
          spanMethod: ({ rowIndex, columnIndex }) => {
            console.log('rowIndex :>> ', rowIndex);
            console.log('columnIndex :>> ', columnIndex);
          },
        },
        mergeRows: [], // 需要合并的行
        tableColumns: [
          { label: '优惠券编号', prop: 'userCardCouponId', minWidth: '250px' },
          { label: '批次号', prop: 'cardCouponId', minWidth: '250px' },
          { label: '名称', prop: 'cardCouponName', minWidth: '200px' },
          { label: '面额', prop: 'faceValue', minWidth: '100px' },
          // { label: '数量', prop: 'num', minWidth: '100px' },
        ],
      };
    },
    computed: {},
    created() {
      this.getDetail();
    },
    methods: {
      // eslint-disable-next-line consistent-return

      statusStr(status) {
        let statusStr = '——';
        if (status === 1) {
          statusStr = '退款中';
        } else if (status === 2) {
          statusStr = '已退款';
        } else if (status === 3) {
          statusStr = '已拒绝';
        }
        return statusStr;
      },

      handleCellClick(row) {
        if (row.rewardType === '1') {
          const routeUrl = this.$router.resolve({
            path: '/marketingCenter/platformMarketingTools/platformCoupon/creditCard',
            query: {
              data: row.rewardId,
            },
          });
          window.open(routeUrl.href, '_blank');
        } else if (row.rewardType === '2') {
          const routeUrl = this.$router.resolve({
            path: '/marketingCenter/platformMarketingTools/platformCoupon/coupon',
            query: {
              data: row.rewardId,
            },
          });
          window.open(routeUrl.href, '_blank');
        }
      },

      /**
       * 获取详情数据
       */
      getDetail() {
        const { id } = this.$route.query;
        cSideDriverAccount.orderUserOfflineRefundDetail({ id }).then(res => {
          if (res) {
            this.detail = res || {};
          }
        });
      },

      dealData(data) {
        return data || '—';
      },
    },
  };
</script>
<style lang="scss" scoped>
  .scan-coupons-detail {
    .all {
      margin-bottom: 16px;
    }
    .form-detail .ykc-detail-item-box {
      .ykc-table {
        padding: 0;
      }
    }
    .fl-right {
      width: 100%;
      display: flex;

      .form-left,
      .form-right {
        flex: 1;
      }
    }

    .refund-status {
      margin-left: 10px;
      font-size: 12px;
      background-color: #ddeafe;
      color: #3f5ebd;
      padding: 4px 10px;
      border-radius: 6px;
    }
  }
</style>
